var map = {
	"./Button/index.jsx": 5708,
	"./Card/index.jsx": 3753,
	"./CardArticle/index.jsx": 9391,
	"./CardWork/index.jsx": 4171,
	"./Carousel/index.jsx": 5442,
	"./Footer/index.jsx": 7885,
	"./Form/index.jsx": 2159,
	"./Header/index.jsx": 4921,
	"./Heading/index.jsx": 6074,
	"./Icon/index.jsx": 4902,
	"./Image/index.jsx": 8305,
	"./Layout/index.jsx": 5230,
	"./Link/index.jsx": 6642,
	"./Logo/index.jsx": 3018,
	"./Modal/index.jsx": 5819,
	"./Navigation/index.jsx": 1802,
	"./SEO/index.jsx": 2439,
	"./Section/index.jsx": 2251,
	"./Separator/index.jsx": 46,
	"./Share/index.jsx": 5867,
	"./Slice/index.jsx": 4620,
	"./Social/index.jsx": 6389,
	"./Text/index.jsx": 9791,
	"./Video/index.jsx": 496,
	"./VideoPlayer/index.jsx": 1186,
	"./Wrapper/index.jsx": 9492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8126;